import Button from "@mui/material/Button"
import Chip from "@mui/material/Chip"
import Tooltip from "@mui/material/Tooltip"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import { IDictionaryItemWithMatch } from "./Interfaces"

export function GlossaryList({
    handleTermClick,
    glossary
}: {
    handleTermClick: (term: string) => () => void
    glossary: IDictionaryItemWithMatch[]
}) {
    const topResults = glossary.slice(0, 1)
    const remainingResults = glossary.slice(2)

    return (
        <>
            <StyledTopResultList>
                {topResults.map(h => (
                    <StyledTopResult key={h.match}>
                        <Typography variant="h3">{h.match}</Typography>
                        <StyledTopResultWord>
                            {h.words.map(word => (
                                <Chip
                                    key={word}
                                    label={word}
                                />
                            ))}
                        </StyledTopResultWord>
                        <Typography variant="body1">{h.description}</Typography>
                    </StyledTopResult>
                ))}
            </StyledTopResultList>
            <StyledRemainingList>
                {remainingResults.map(p => (
                    <Tooltip
                        key={p.match}
                        title={p.description}
                        placement="bottom-end">
                        <li>
                            <StyledButton onClick={handleTermClick(p.match)}>
                                {p.match}
                            </StyledButton>
                        </li>
                    </Tooltip>
                ))}
            </StyledRemainingList>
        </>
    )
}

const StyledButton = styled(Button)(({ theme }) => ({
    padding: theme.spacing(0),
    textAlign: "left",
    display: "block"
}))

const StyledTopResultList = styled("ul")(({ theme }) => ({
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginRight: theme.spacing(4),
    marginBottom: theme.spacing(0)
}))

const StyledTopResult = styled("li")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1)
}))

const StyledTopResultWord = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    alignItems: "center"
}))

const StyledRemainingList = styled("ul")(({ theme }) => ({
    columnCount: 1,
    gap: theme.spacing(1),
    listStyle: "none",
    [theme.breakpoints.up("sm")]: {
        columnCount: 2
    },
    [theme.breakpoints.up("md")]: {
        columnCount: 4
    }
}))
